import React, { useContext, useEffect } from 'react';

import AppContext from './context';
import StepNavigation from './components/StepNavigation';
import TypeSelector from './components/TypeSelector';
import GradeSelector from './components/GradeSelector';
import FamilySelector from './components/FamilySelector';
import GroupSelector from './components/GroupSelector';
import GenderSelector from './components/GenderSelector';
import Results from './components/Results';

const getParam = name => {
  const requestedParam = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${requestedParam}=([^&#]*)`);
  let results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const App = props => {
  const context = useContext(AppContext);

  useEffect(() => {
    context.getDisplayText();

    const param = getParam('type');
    if (param) {
      const updatedFilters = { ...context.filters };
      updatedFilters.group = param;
      context.setFilters(updatedFilters);

      context.setStep(2);
      context.setProgress(2);
    } else {
      context.setStep(1);
      context.setProgress(1);
    }
  }, []);

  return (
    <div className="program-finder">
      <StepNavigation/>

      {context.step === 1 ?
        <TypeSelector/>
      : null}

      {context.step === 2 && context.filters.group === 'Individual' ?
        <GradeSelector/>
      : null}

      {context.step === 2 && context.filters.group === 'Family' ?
        <FamilySelector/>
      : null}

      {context.step === 2 && context.filters.group === 'Group' ?
        <GroupSelector/>
      : null}

      {context.step === 3 && context.filters.group === 'Individual' ?
        <GenderSelector/>
      : null}

      {context.step === 4 ?
        <Results/>
      : null}
    </div>
  );
}

export default App;